import React, {Fragment, useState, useEffect, useRef} from 'react';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {Navigation} from '@homeaway/react-navigation';
import {Waypoint} from 'react-waypoint';

import classNames from 'classnames';
import './Navbar.less';

const smoothScroll = (element, offset) => {
    const offsetTop = element.getBoundingClientRect().top + window.pageYOffset;
    window.scroll({
        top: offsetTop - offset,
        behavior: 'smooth',
    });
};

/* eslint-disable complexity */
const Navbar = ({links, active, button, isMobile}) => {
    const navbarRef = useRef();
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [fixed, setFixed] = useState(false);

    useEffect(() => {
        setNavbarHeight(navbarRef.current.clientHeight);
    });

    /**
     * fix navbar if browser renders page mid-way down
     */
    useEffect(() => {
        if (window.scrollY > navbarHeight && !fixed) {
            setFixed(true);
        }
    }, []);

    /**
     * Scroll to section if, on initial render, active link doesn't match scroll position
     */
    useEffect(() => {
        const hashIndex = links.findIndex(
            ({href}) => window.location.hash === href,
        );
        if (hashIndex > -1) {
            const id = links[hashIndex].href.slice(1);
            const element = document.getElementById(id);
            if (element.getBoundingClientRect().top !== window.scrollY) {
                smoothScroll(element, navbarHeight);
            }
        }
    }, []);

    useEffect(() => {
        if (links.length > 1) {
            require('smoothscroll-polyfill').polyfill();
        }
    });

    const handleLinkClick = (event, index) => {
        const id = links[index].href.slice(1);
        const element = document.getElementById(id);

        if (element) {
            event.preventDefault();
            smoothScroll(element, navbarHeight);

            if (window.history.pushState) {
                window.history.pushState(null, null, `#${id}`);
            } else {
                window.location.hash = id;
            }
        }
    };

    const handleWaypointEnter = (e) => {
        if (e.previousPosition === 'above') {
            setFixed(false);
        }
    };

    const handleWaypointLeave = (e) => {
        if (e.currentPosition === 'above') {
            setFixed(true);
        }
    };

    if (isMobile) {
        links.length = 1;
    }

    return (
        <Fragment>
            <Waypoint
                onEnter={handleWaypointEnter}
                onLeave={handleWaypointLeave}
            />
            <div
                style={{
                    /* stylelint-disable-next-line */
                    height: navbarHeight,
                }}
            >
                <div
                    className={classNames(
                        'navigation-bar',
                        fixed && `navigation-bar--fixed`,
                    )}
                    ref={navbarRef}
                >
                    <div className="container">
                        <div className="navbar-flex">
                            <Navigation
                                className={classNames(
                                    links.length > 1 && 'with-spacer',
                                )}
                                links={links}
                                activeIndex={isMobile ? 1 : active}
                                onLinkClick={handleLinkClick}
                                noMobileSelect
                            />

                            {button}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default determineIfMobile(Navbar);
